import block from 'bem-cn-lite';
import {Button, Icon} from '@gravity-ui/uikit';
import {Bars, Magnifier, Xmark} from '@gravity-ui/icons';
import {FC, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {SearchInput} from '../SearchInput/SearchInput';

import './MobileMenu.scss';

const b = block('mobile-menu-main-header');

interface MobileMenuProps {
    isOpen: boolean;
    onToggle: () => void;
    onSearchToggle: (isOpen: boolean) => void;
}

export const MobileMenu: FC<MobileMenuProps> = ({isOpen, onToggle, onSearchToggle}) => {
    const location = useLocation();
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const handleSearchToggle = () => {
        const newState = !isSearchOpen;
        setIsSearchOpen(newState);
        onSearchToggle(newState);
    };

    const handleCancelSearch = () => {
        setIsSearchOpen(false);
        onSearchToggle(false);
    };

    useEffect(() => {
        if (location.pathname === '/home' || location.pathname === '/search') {
            handleCancelSearch();
        }
    }, [location.pathname]);

    return (
        <div className={b()}>
            {!isSearchOpen ? (
                <>
                    <Button view="normal" size="xl" onClick={onToggle}>
                        <Icon data={isOpen ? Xmark : Bars} width={20} height={20} />
                    </Button>

                    {location.pathname !== '/home' && location.pathname !== '/search' && !isOpen && (
                        <Button view="normal" size="xl" onClick={handleSearchToggle}>
                            <Icon data={Magnifier} width={20} height={20} />
                        </Button>
                    )}
                </>
            ) : (
                <>
                    <SearchInput />

                    <Button view="flat" size="xs" onClick={handleCancelSearch}>
                        Отмена
                    </Button>
                </>
            )}
        </div>
    );
};
